import { useEffect, useState } from "react";
import CustomScrollbar from "./CustomScrollbar";

const CustomScrollbarContainer=()=>{
    const [isVisible,setIsVisible]=useState(false);

    useEffect(()=>{
        setIsVisible(true);
    },[])

    return(
        <>
            {
                isVisible?
                    <CustomScrollbar/>
                :
                    null
            }
        </>
    )
}

export default CustomScrollbarContainer;